/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import about from './images/image1.webp';

const AboutInaAcc = () => {
    const theme = useTheme();

    const RightSide = () => (
        <Box>
            <Box marginBottom={2}>
                <Typography
                    color="text.primary"
                    variant={'body1'}
                    align={'justify'}
                >
                    Intensive and Acute Cardiovascular Care (ACC), is a working
                    group under Indonesian Heart Association (IHA), established
                    in 2012 in response to the recognition of complexities
                    surrounding the care of patients with acute cardiovascular
                    conditions. Initially focusing on acute coronary syndrome
                    and acute heart failure, this territory quickly expanded
                    toward other aspects of care for the acutely and critically
                    ill cardiovascular patients, such as mechanical circulatory
                    support, respiratory support, renal replacement therapy and
                    general preventive measures for infections. This is
                    accompanied by the development of cardiac critical care as
                    an emerging subspecialty of cardiovascular medicine. Cardiac
                    intensivists in the modern era should have proper training
                    in general cardiology, combined with additional competency
                    in critical care. As interventional cardiology, structural
                    heart disease, electrophysiology, advanced heart failure and
                    transplantation continue to offer new treatment options for
                    complex high-risk patients, cardiovascular critical care is
                    of utmost importance to provide collaborative care among
                    these disciplines.
                </Typography>
                <br />
                <Typography
                    color="text.primary"
                    variant={'body1'}
                    align={'justify'}
                >
                    Our unique community consists of cardiologists who have
                    completed their training in acute and intensive
                    cardiovascular care and other members of IHA with special
                    interest in this field. Currently we have more than 50
                    members under the working group wing, and once every two
                    years the Indonesia Intensive and Acute Cardiovascular Care
                    Meeting (Ina-ACC) is organized as a platform for scientific
                    exchanges among members and also the national medical
                    community in Indonesia. This year on 2024 will be our 6th
                    bi-annual meeting to share knowledge and experiences and
                    reach our common goal of improving cardiovascular
                    collaborative care in Indonesia through maintaining and
                    improving core competencies of all health care professionals
                    working in this field.
                </Typography>
            </Box>
            <Box marginTop={4}>
                <Button
                    variant={'contained'}
                    size={'large'}
                    endIcon={
                        <Box
                            component={'svg'}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            width={24}
                            height={24}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                        </Box>
                    }
                >
                    See more
                </Button>
            </Box>
        </Box>
    );
    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Box
                    sx={{
                        // maxWidth: 450,
                        position: 'relative',
                        marginX: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            borderRadius: '2.75rem',
                            boxShadow: 1,
                            //   width: '75% !important',
                            marginX: 'auto',
                        }}
                    >
                        <Box>
                            <Box
                                position={'relative'}
                                zIndex={2}
                                maxWidth={1}
                                height={'auto'}
                                sx={{ verticalAlign: 'middle' }}
                            >
                                <Box
                                    component={CardMedia}
                                    borderRadius={2}
                                    // width={1}
                                    // height={1}
                                    minHeight={320}
                                    image={about}
                                />
                                {/* <PhoneSkeletonIllustration /> */}
                            </Box>
                            <Box
                                position={'absolute'}
                                top={'2.4%'}
                                left={'4%'}
                                width={'92.4%'}
                                height={'96%'}
                                sx={{
                                    '& .lazy-load-image-loaded': {
                                        height: 1,
                                        width: 1,
                                    },
                                }}
                            >
                                <Box
                                    component={LazyLoadImage}
                                    src={
                                        theme.palette.mode === 'light'
                                            ? 'https://assets.maccarianagency.com/screenshots/crypto-mobile.png'
                                            : 'https://assets.maccarianagency.com/screenshots/crypto-mobile--dark.png'
                                    }
                                    alt="Image Description"
                                    effect="blur"
                                    width={1}
                                    height={1}
                                    sx={{
                                        objectFit: 'cover',
                                        borderRadius: '2.5rem',
                                        filter:
                                            theme.palette.mode === 'dark'
                                                ? 'brightness(0.7)'
                                                : 'none',
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Grid>
            <Grid item container alignItems={'center'} xs={12} md={6}>
                <Box>
                    <RightSide />
                </Box>
            </Grid>
        </Grid>
    );
};

export default AboutInaAcc;
